import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getSaveButtonStatus } from "../../../validation/save-validation";

const SaveChangesButton = ({ isSaving, onSave }) => {
  const [isEnabled, setIsEnabled] = useState(false);

  const { setup, updatedVoice, updatedGreeting } = useSelector((state) => state.info);
  const companyDirectory = useSelector((state) => state.companyDirectory);
  const calendarManagement = useSelector((state) => state.calendarManagement);
  const knowledgeBase = useSelector((state) => state.knowledgeBase);

  useEffect(() => {
    const isEnabled = getSaveButtonStatus();
    setIsEnabled(isEnabled);
  }, [setup, companyDirectory, calendarManagement, knowledgeBase, updatedVoice, updatedGreeting]);

  return (
    <button
      onClick={onSave}
      className={`w-100 flex items-center justify-center action-button border border-ov-green text-ov-green hover:bg-ov-green hover:text-white ${
        !isSaving && isEnabled ? "" : "disabled"
      }`}
    >
      Save Changes
      {isSaving && (
        <svg
          className="animate-spin ml-2 h-5 w-5 text-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          role="status"
          aria-label="Saving…"
        >
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
          {/* Fixed path; inherits currentColor */}
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      )}
    </button>
  );
};

export default SaveChangesButton;
